<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list dense>
        <v-list-item class="px-2" v-if="user.loggedIn">
        <v-list-item-avatar>
          <v-img :src="user.images[0].url"></v-img>
        </v-list-item-avatar>

        <v-list-item-title>{{user.displayName}}</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
        <v-list-item
          to="/"
          link
        >
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          to="/playlists"
          link
        >
          <v-list-item-action>
            <v-icon>mdi-playlist-play</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              All Playlists
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-subheader class="mt-4 grey--text text--darken-1">Friends</v-subheader>
        <v-list>
          <v-list-item
            v-for="item in playlistsOwners"
            :key="item.id"
            @click="addFriend(item)"
          >
            <v-list-item-avatar>
              <v-img
                :src="item.imageUrl"
                alt=""
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-icon color="green">mdi-account-circle-outline</v-icon>
                  </v-row>
                </template>
              </v-img>
            </v-list-item-avatar>
            <v-list-item-title v-text="item.display_name"></v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list-item link @click="login()" v-if="!user.loggedIn">
          <v-list-item-action>
            <v-icon color="grey darken-1">mdi-login</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">Login</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item link @click="logout()" v-if="user.loggedIn">
          <v-list-item-action>
            <v-icon color="grey darken-1">mdi-login</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">Logout</v-list-item-title>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      clipped-left
      color="green"
      dense
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-icon
          class="mx-4"
          large
        >
          mdi-shuffle
        </v-icon>
      <v-toolbar-title class="mr-12 align-center">
        <span class="title">Spuffle {{version}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-row
        align="center"
        style="max-width: 650px"
      >
        <v-text-field
          :append-icon-cb="() => {}"
          placeholder="Search..."
          single-line
          append-icon="mdi-magnify"
          color="white"
          hide-details
        ></v-text-field>
      </v-row> -->
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld'
import { mapGetters } from 'vuex'
import safeGet from 'just-safe-get'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data: () => ({
    drawer: null,
    items: [
      {
        icon: 'mdi-playlist-plus',
        text: 'Compose a shuffled playlist',
        link: '/compose'
      },
      {
        icon: 'mdi-playlist-play',
        text: 'Playlists',
        link: '/playlists'
      }
    ]
  }),
  computed: {
    environment: function () {
      return process.env.NODE_ENV
    },
    version: function () {
      return process.env.VUE_APP_VERSION
    },
    authBase: function () {
      return process.env.VUE_APP_AUTH_URL_BASE
    },
    ...mapGetters({
      user: 'getCurrentUser',
      authToken: 'getUserToken',
      playlists: 'getPlaylists',
      playlistsOwners: 'getPlaylistOwners'
    })

  },
  methods: {
    get (arg1, arg2) {
      return safeGet(arg1, arg2)
    },
    login () {
      const callbackUri = this.authBase
      // const callbackUriProduction = 'https://https://spuffle-shuffler.web.app/callback'
      const popup = window.open(`https://accounts.spotify.com/authorize?client_id=250727fed2ec47b3a3f64e00c9e08f9d&response_type=token&redirect_uri=${callbackUri}&scope=user-read-private%20user-read-email%20user-follow-read%20playlist-modify-private&show_dialog=true`, 'Login with Spotify', 'width=800,height=600')

      window.spotifyCallback = (payload) => {
        // alert(payload)

        popup.close()

        fetch('https://api.spotify.com/v1/me', {
          headers: {
            Authorization: `Bearer ${payload}`
          }
        }).then(response => {
          this.$store.commit('setAuthToken', payload)
          return response.json()
        }).then(data => {
          this.$store.commit('setUser', data)
          this.me = data
          this.$store.dispatch('fetchFollows')
        })
      }
    },
    logout () {
      this.$store.dispatch('resetFriends')
      this.$router.push('/')
    },
    addFriend (id) {
      this.$store.commit('addFriend', id)
    }
  },
  mounted () {
    this.token = window.location.hash.substr(1).split('&')[0].split('=')[1]
    if (this.token) {
      // alert(this.token)
      window.opener.spotifyCallback(this.token)
    }
    if (this.authToken && this.playlists === []) {
      this.$store.dispatch('fetchFollows')
    }
  }
}
</script>
